import { initialState } from "./state"

export default {
  setOffers: (state, offers) => {
    state.offers = offers
  },
  resetOffers: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
